import { render } from "./EditCountry.vue?vue&type=template&id=229210fc&scoped=true"
const script = {}

import "./EditCountry.vue?vue&type=style&index=0&id=229210fc&scoped=true&lang=css"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229210fc"]])

export default __exports__